import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jdzx",
  "use": "icon-jdzx-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" viewBox=\"0 0 14 11\" id=\"icon-jdzx\">\n<path fill-rule=\"evenodd\" fill=\"gray\" d=\"M13.214,0.125 C12.785,0.125 12.438,0.473 12.438,0.902 L12.438,5.951 C12.438,6.165 12.264,6.339 12.050,6.339 L2.673,6.339 L4.452,4.558 C4.756,4.255 4.756,3.763 4.452,3.460 C4.149,3.156 3.658,3.156 3.355,3.460 L0.252,6.567 C0.181,6.638 0.124,6.724 0.085,6.819 C0.006,7.009 0.006,7.223 0.085,7.413 C0.124,7.508 0.181,7.594 0.253,7.666 L3.355,10.772 C3.507,10.924 3.705,11.000 3.904,11.000 C4.102,11.000 4.301,10.924 4.452,10.772 C4.756,10.469 4.756,9.977 4.452,9.674 L2.673,7.893 L12.050,7.893 C13.120,7.893 13.990,7.022 13.990,5.951 L13.990,0.902 C13.990,0.473 13.643,0.125 13.214,0.125 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jdzx.svg
// module id = naPa
// module chunks = 12